import React, { useState, useEffect } from 'react';
import { useSpring, animated } from '@react-spring/web';
import axios from 'axios';

import { buildSafeAuthUrl, sanitizeForDisplay, sanitizeUrl } from '../utils/sanitize';
import icoRetrn from "../assets/img/return-arrow.svg";
import SvgLoader from './animated/SvgLoader';
const ShareTiktokComponent = ({ videoId, onClose, reAuth }) => {
  const [title, setTitle] = useState('');
  const [allowComments, setAllowComments] = useState(true);
  const [allowShares, setAllowShares] = useState(true);
  const [allowDuets, setAllowDuets] = useState(false);
  const [discloseVideoContent, setDiscloseVideoContent] = useState(false);
  const [yourBrand, setYourBrand] = useState(false);
  const [brandedContent, setBrandedContent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isPublishing, setIsPublishing] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);
  const [error, setError] = useState(null);
  const [tiktokProfile, setTiktokProfile] = useState();
  const [profileLoaded, setProfileLoaded] = useState(false);

  const currentUrl = window.location.pathname;

  const springProps = useSpring({
    opacity: 1,
    transform: 'translateY(0px)',
    from: { opacity: 0, transform: 'translateY(20px)' },
    config: { tension: 280, friction: 20 },
  });

  useEffect(() => {
    const fetchProfile = async () => {
      const accessToken = localStorage.getItem('at_tktok'); // Obtener access token
      if (accessToken) {
        try {
          setIsLoading(true);
          const formData = new FormData();
          formData.append('code', accessToken);
          formData.append('rf', window.localStorage.getItem('rt_tktok'));
          formData.append('type', 'tiktok_profile');
          formData.append('redirect_uri', process.env.REACT_APP_TIKTOK_REDIRECT);
          const response = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);

          if (response.data.success) { // Verifica response.data.success
            const profile = response.data.data;
            if (profile) {
              setTiktokProfile({
                ...profile,
                creator_nickname: sanitizeForDisplay(profile.creator_nickname || ''),
                creator_avatar_url: sanitizeUrl(profile.creator_avatar_url, { allowData: true }) || '',
              });
            }
          }
        } catch (error) {
          console.error("Error al obtener el perfil:", error);
          localStorage.removeItem('at_tktok');
          localStorage.removeItem('rt_tktok');
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchProfile();
  }, []);
  useEffect(() => {
    if (tiktokProfile) {
      setProfileLoaded(true);
    }
  }, [tiktokProfile]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsPublishing(true);
    setError(null);
    setResponseMessage(null);

    const safeTitle = sanitizeForDisplay(title);
    const accessToken = localStorage.getItem('at_tktok'); // Obtener access token
    if (accessToken) {
      try {
        const formData = new FormData();
        formData.append('title', safeTitle);
        formData.append('allowComments', allowComments);
        formData.append('allowShares', allowShares);
        formData.append('allowDuets', allowDuets);
        formData.append('discloseVideoContent', discloseVideoContent);
        formData.append('yourBrand', yourBrand);
        formData.append('brandedContent', brandedContent);
        formData.append('videoId', videoId);
        formData.append('code', accessToken);
        formData.append('redirect_uri', process.env.REACT_APP_TIKTOK_REDIRECT);
        formData.append('type', 'tiktok_callback');
        const response = await axios.post(process.env.REACT_APP_LAMBDA_ENDPOINT, formData);

        if (response.data.success) {
          setResponseMessage('Hemos publicado tu video en tu cuenta de Tiktok.');
          // Considera redirigir al usuario o mostrar el video publicado
          setTimeout(() => {
            handleClose();
          }, 3000);
        } else {
          handleError(response, currentUrl);
        }
      } catch (err) {
        console.error("Error al enviar la solicitud:", err);
        handleError(err, currentUrl);
      } finally {
        setIsPublishing(false);
      }
    } else {
      reAuth(currentUrl);
    }
  };

  const handleError = (error, currentUrl) => {
    localStorage.removeItem('code_tk');
    console.error('Error publicando en TikTok:', error);

    if (error.response?.status === 401 || error.response?.data.message === 'Authorization code is expired.') {
      localStorage.removeItem('tiktokAccessToken');
      reAuth();
    } else {
      setError(sanitizeForDisplay(error.response?.data.message || 'Error al publicar en TikTok.'));
    }
  };

  const getSafeImageUrl = (url) => {
    if (!url || typeof url !== 'string') return null;

    try {
        const parsedUrl = new URL(url);
        // Validar estrictamente que sea una imagen servida por HTTP o HTTPS
        if (parsedUrl.protocol === 'https:' || parsedUrl.protocol === 'http:') {
            return parsedUrl.toString();
        }
    } catch (error) {
        // Si new URL() falla, significa que el string no era una URL válida
        console.warn("URL de avatar inválida detectada.");
    }
    return null;
  };

  const safeAvatarUrl = getSafeImageUrl(tiktokProfile?.creator_avatar_url);

  const encodedAvatarUrl = safeAvatarUrl ? encodeURI(safeAvatarUrl) : null;

  const handleClose = () => {
    onClose(); 
  };

  return (
    <animated.div style={springProps} className="animated-form-container formTiktok">
      <div>
        <button className="return" onClick={handleClose}>
          <img src={icoRetrn} alt='Botón regresar' /> </button>
        <h2>Subir a Tiktok</h2>
      </div>
      {isLoading ? (
        <div className="loading w-100 text-center">
          <SvgLoader />
        </div>
      ) : (
        <>
          {tiktokProfile && profileLoaded ? (
            <>
              <div className="user-info mt-3">
                {encodedAvatarUrl ? (
                  <img src={encodedAvatarUrl} alt={tiktokProfile.creator_nickname || 'Avatar de TikTok'} className="avatar" />
                ) : null}
                <span className="username ms-3">@{tiktokProfile.creator_nickname || 'usuario'}</span>
              </div>

              <form onSubmit={handleSubmit}>
                <label>
                  Descripción
                  <textarea
                    type="text"
                    placeholder="Mi lavadora baila con ritmo. #DancingWashers"
                    value={title}
                    onChange={(e) => setTitle(sanitizeForDisplay(e.target.value))}
                    required
                    className="description"
                    maxlength="100">
                  </textarea>
                </label>

                <div className="permisions">
                  <p>
                    Permitir que los usuarios:
                  </p>
                  <div className='d-flex justify-content-between'>
                    <label >
                      <span className={allowComments ? 'active' : ''}> </span>
                      <input
                        type="checkbox"
                        checked={allowComments}
                        onChange={(e) => setAllowComments(e.target.checked)}
                      />
                      Comentarios
                    </label>

                    <label>
                      <span className={allowShares ? 'active' : ''}> </span>
                      <input
                        type="checkbox"
                        checked={allowShares}
                        onChange={(e) => setAllowShares(e.target.checked)}
                      />
                      Compartir
                    </label>

                    <label>
                      <span className={allowDuets ? 'active' : ''}> </span>
                      <input
                        type="checkbox"
                        checked={allowDuets}
                        onChange={(e) => setAllowDuets(e.target.checked)}
                      />
                      Dúos
                    </label>
                  </div>

                </div>

                <div className="slide-option">
                  <label>
                    Publicar contenido de video
                    <span className={discloseVideoContent ? 'active' : ''}> </span>
                    <input
                      type="checkbox"
                      checked={discloseVideoContent}
                      onChange={(e) => setDiscloseVideoContent(e.target.checked)}
                    />
                  </label>
                  <p>
                    Continúe leyendo para informar que este video promociona
                    bienes o servicios a cambio de algo o valor.
                  </p>
                </div>

                {discloseVideoContent && (
                  <div className="disclose-content">
                    <div className="slide-option">
                      <label>
                        <input
                          type="checkbox"
                          checked={yourBrand}
                          onChange={(e) => setYourBrand(e.target.checked)}
                        />
                        Tu marca
                        <span className={yourBrand ? 'active' : ''}> </span>
                      </label>
                      <p>
                        Estás promocionando tu propio negocio o a ti mismo. Este video se clasificará como orgánico de marca.
                      </p>
                    </div>
                    <div className="check-option">
                      <label>
                        <input
                          type="checkbox"
                          checked={brandedContent}
                          onChange={(e) => setBrandedContent(e.target.checked)}
                        />
                        Contenido de marca
                        <span className={brandedContent ? 'active' : ''}> </span>
                      </label>
                      <p>
                        Estás promocionando otra marca o un tercero. Este video se clasificará como contenido de marca.
                      </p>
                    </div>
                  </div>
                )}

                <p>
                  Al publicar, aceptas nuestra Política de uso de música.
                </p>

                <button disabled={isPublishing} onClick={handleSubmit}>
                  {isPublishing ? 'Publicando...' : 'Publicar'}
                </button>
                {responseMessage && <p className="success-message">{sanitizeForDisplay(responseMessage)}</p>}
                {error && <p className="error-message">{sanitizeForDisplay(error)}</p>}
              </form>
            </>
          ) : (
            <>
              <p className='mt-5'>Inicia sesión con tu cuenta de Tiktok</p>
              <p className='mt-3'>
                {(() => {
                  const safeAuthUrl = buildSafeAuthUrl(
                    'https://www.tiktok.com/v2/auth/authorize',
                    process.env.REACT_APP_TIKTOK_REDIRECT || '',
                    currentUrl || ''
                  );

                  return safeAuthUrl ? (
                    <a
                      href={`${safeAuthUrl}&client_key=${encodeURIComponent(process.env.REACT_APP_TIKTOK_CLIENT_KEY || '')}&scope=video.publish&response_type=code`}
                      className='btn btn-link'
                    >
                      Login On Tiktok
                    </a>
                  ) : null;
                })()}
              </p>
            </>
          )}
        </>)}
    </animated.div >
  );
};

export default ShareTiktokComponent;